var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTumbler = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#db011c",
  "data-name": "Group 32874"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32873"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40 57.597a17.7 17.7 0 1 1 17.7-17.7 17.725 17.725 0 0 1-17.7 17.7m0-33.443a15.738 15.738 0 1 0 15.738 15.738A15.756 15.756 0 0 0 40 24.154",
  "data-name": "Path 19143"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.639 61.532H18.36V18.253h43.279Zm-41.311-1.967h39.344V20.22H20.327Z",
  "data-name": "Path 19144"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32872"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.229 61.543 44.146-44.472 1.396 1.385L18.625 62.93z",
  "data-name": "Rectangle 26175"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.234 18.45 1.396-1.385 44.135 44.483-1.396 1.385z",
  "data-name": "Rectangle 26176"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M80 80H0V0h80ZM1.311 78.692h77.377V1.311H1.311Z",
  "data-name": "Path 19145"
}))));
export default SvgTumbler;